import { render, staticRenderFns } from "./customertransferorder.vue?vue&type=template&id=55d1e620"
import script from "./customertransferorder.vue?vue&type=script&lang=js"
export * from "./customertransferorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports